import React from 'react';
import ReactDOM from 'react-dom/client';
import styled from "styled-components";
import { contactList } from "../mockData";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  border-right: 1px solid #dadada;
  flex:1.6;
  `;

  const ProfileInfoDiv= styled.div`
  display: flex;
  flex-direction: row;
  background: #ededed;
  padding: 10px;
  `;


  const SearchBox = styled.div`
  display: flex;
  flex-direction: row;
  background:#f6f6f6;
  padding: 10px;
  `;

  const ProfileImage = styled.img`
    width: 35px;
    height: 35px;
    border-radius: 50%
  `;


  // the export enables us to use the searchcontainer in coversationComponent
  export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  background: white;
  border-radius: 16px;
  width: 100%;
  padding: 5px 10px;
  `;

  const SearchIcon = styled.img`
  width:20px;
  height:20px;
  padding-top: 0.2rem;
  padding-right: 0.3rem;
  margin-left: 0.5rem;
  `;

  export const SearchInput = styled.input`
  width:100%;
  height:25px;
  outline: none;
  border: none;
  font-size: 15px;
  margin-left: 10px;
  `;
  
  const ContactItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid #f2f2f2;
  background: white;
  cursor: pointer;
  padding: 15px 12px;
  &:hover {
    background: #ebebeb;
  }
  `;

  const ProfileIcon = styled(ProfileImage)`
  width: 38px;
  height: 38px;
  `;

  const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 12px;
  `;

  const ContactName = styled.span`
  width: 100%;
  font-size: 16px;
  color: black;
  `;

  const MessageText = styled.span`
  width: 100%;
  font-size: 14px;
  margin-top: 3px;
  color: rgba(0, 0, 0, 0.8);
  `;

  const MessageTime = styled.span`
  font-size: 12px;
  margin-right: 10px;
  color: rgba(0, 0, 0, 0.45);
  white-space: nowrap;
  `;

const ContactComponent =(props)=>{
  const { userData,setChat } = props;
  return (
  <ContactItem onClick={() => setChat(userData)}>
    <ProfileIcon src={userData.profilePic} />
    <ContactInfo>
<ContactName>{userData.name}</ContactName>
<MessageText>{userData?.lastText}</MessageText>
    </ContactInfo>
    <MessageTime>{userData?.lastTextTime}</MessageTime>
    </ContactItem>
  );
};

// here we create a funtion  to return or log out a rendered component 
const ContactListComponent =(props)=>{
  return( 
  <Container>
  <ProfileInfoDiv>
    <ProfileImage src="/profile/debo.jpeg" />
  </ProfileInfoDiv>
  <SearchBox>
    <SearchContainer>
    <SearchIcon src={"./search-icon.svg"} />
    <SearchInput placeholder="Search or start new chat"/>
      </SearchContainer>
    </SearchBox>
   {contactList.map((userData) => (
   <ContactComponent userData={userData} setChat={props.setChat} />
   ))}
   </Container>
   );
};


export default ContactListComponent;